export const shortenString = (str, length) => {
    return `${str.slice(0, length)}...${str.slice(str.length - length)}`;
};
export const formatInvoiceNumber = (number) => {
    return String(number).padStart(6, '0');
};
